import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {GenerateCouponResponse} from '@/Screens/RenewalPuzzleChallenge/types';

export default function useGeneratePuzzleCoupon(
  onSuccess?: (data: GenerateCouponResponse) => void,
  onError?: (err: any) => void,
) {
  return useMutation<GenerateCouponResponse, Error, {solved_count: number}>(
    async ({solved_count}) => {
      // Auth token is injected automatically by ChessRestClient's request interceptor
      const response = await ChessRestClient.post(
        'subscription/v1/generate-puzzle-coupon/',
        {solved_count},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (onSuccess) onSuccess(data);
      },
      onError: err => {
        if (onError) onError(err);
      },
    },
  );
}
